import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { navItems } from "@/constants/nav";

export default function NotFound() {
  useDocumentMeta({
    title: "页面未找到 - 百度一下",
    description: "你访问的页面不存在，返回百度一下首页继续搜索新闻、视频与百科内容。",
    keywords: "百度一下,页面未找到",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />

      <main className="flex flex-1 items-center justify-center px-4 py-20 md:px-6">
        <div className="mx-auto flex w-full max-w-xl flex-col items-center text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-question-mark text-3xl" />
          </span>
          <p className="mt-6 font-heading text-5xl font-black text-primary-500 md:text-6xl">404</p>
          <h1 className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            没有找到这个页面
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            你访问的地址可能已失效或输入有误。可以回到首页重新搜索，或前往下面的频道继续浏览。
          </p>

          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              返回首页
            </Link>
            <Link
              to="/hotsearch"
              className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 whitespace-nowrap transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看热门搜索
            </Link>
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {navItems.slice(1).map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="rounded-full border border-background-300 px-3 py-1.5 text-sm text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}